import styled, { css } from 'styled-components';

interface StyledDivProps {
  $gap: string;
  $align: string;
  $justify: string;
  $direction: string;
  $width: string;
  $height: string;
}

const StyledDiv = styled.div<StyledDivProps>(
  ({ $gap, $align, $justify, $direction, $width, $height }) => css`
    display: flex;
    flex-direction: ${$direction};
    gap: ${$gap};
    align-items: ${$align};
    justify-content: ${$justify};
    width: ${$width};
    height: ${$height};
    flex-wrap: wrap;
  `
);

interface TubeProps {
  children: React.ReactNode;
  gap?: string;
  align?: string;
  justify?: string;
  direction?: string;
  width?: string;
  height?: string;
}

export function Tube({
  children,
  gap = '0',
  align = 'flex-start',
  justify = 'flex-start',
  direction = 'column',
  width = '100%',
  height = 'auto',
}: TubeProps) {
  return (
    <StyledDiv
      $width={width}
      $gap={gap}
      $align={align}
      $justify={justify}
      $direction={direction}
      $height={height}
    >
      {children}
    </StyledDiv>
  );
}
